// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"506596fe","118":"448e2fbf","355":"ff5f1328","436":"653028f3","465":"4c8391dd","538":"c24b60be","605":"f3e1acb4","681":"3aaf1ad8","738":"0a437ef2","785":"94838d50","835":"f2bfc050","850":"52dcf955","944":"fc08a31a"}[chunkId] + ".chunk.js";
};